import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
	cn,
} from "@babybjorn/ui";
import type { StoryblokRichTextNode } from "@storyblok/react";
import type { ReactElement } from "react";
import GridItem from "../../components/general/GridItem";
import Icon from "../../components/general/Icon";
import RichText from "../../components/general/RichText";
import ScrollSpyItem from "../../components/general/ScrollSpy/ScrollSpyItem";
import { useAppState } from "../../context/app/context";
import {
	filterByStore,
	type StoreItem,
} from "../../utils/storyblok/store-filters";
import { notNull } from "../../utils/type-guards/general";

const AccordionModule = ({ items }: Queries.AccordionModuleFragment) => {
	const { siteConfig } = useAppState();
	if (!items) return null;
	const accordionItems = items
		.filter((i) => filterByStore(i as StoreItem, siteConfig.store))
		.filter(notNull)
		.map((item) => ({
			label: item.label,
			icon: item.icon,
			defaultOpen: item.open_by_default,
			content: item.content,
		}));

	return accordionItems.length > 0 ? (
		<GridItem>
			<ScrollSpyItem
				id="product-details"
				className={cn("gap-bb grid grid-cols-1", {
					"md:grid-cols-2": items.length > 1,
				})}
			>
				{accordionItems.map((item, index) => (
					<Accordion
						key={`product-accordion-${index}`}
						type="multiple"
						defaultValue={accordionItems.map((item, index) =>
							item.defaultOpen ? `product-accordion-${index}` : "",
						)}
					>
						<AccordionItem
							value={`product-accordion-${index}`}
							className="not-last:border-b-0"
						>
							<AccordionTrigger className="data-[state=open]:rounded-b-0 rounded-t-md data-[state=closed]:rounded-b-md">
								<span className="flex items-center gap-2">
									{item.icon && <Icon icon={item.icon} />}
									{item.label}
								</span>
							</AccordionTrigger>
							<AccordionContent className="rounded-b-md">
								{item.content && (
									<RichText
										content={
											item.content as StoryblokRichTextNode<ReactElement>
										}
									/>
								)}
							</AccordionContent>
						</AccordionItem>
					</Accordion>
				))}
			</ScrollSpyItem>
		</GridItem>
	) : null;
};
export default AccordionModule;
